import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { BtnComponent } from '../../components/button';
import { PageDialogContent, PageDialogFooter } from '../../components/dialog';
import SpeechMic from '../../components/mic';
import { TextAreaField } from '../../components/reactHookFormFields/textAreaFields';
import { useGroupChatContext } from '../../context/groupchatContext';
import { useSendMessageMutation, useSpeechToTextMutation } from '../../services/chatService';

const ProblemReportForm = ({problemReport, cancelProblemReportPopup}) => {

    const [isProcessing, setIsProcessing] = useState(false);
    const [sendMessage] = useSendMessageMutation();
    const [disableBtn, setDisableBtn] = useState(false);

    const groupChatContext = useGroupChatContext();
    const {selectedChat} = useMemo(() => ({
        selectedChat: groupChatContext.selectedChat,
    }));

    const {
        handleSubmit,
        getValues,
        setValue,
        control,
        formState: { errors },
    } = useForm({defaultValues: {}});

    const onSubmitForm = async (values) => {

        let isFormValid = false;

        Object.keys(values).forEach((key) => {
            if (key.includes('question_')) {
                if (values[key]) {
                    isFormValid = true;
                }
            }
        });

        if(!isFormValid){
            toast.error('Please answer at least one question');
            return;
        }

        const questionsText = (problemReport?.data?.question_json || [])
        .map((item, index) => `<span class="font-semibold">Q${index+1}. ${item?.text}</span><br/>${values[`question_${index}`] || '-'}`)
        .join('<br/>');

        const payload = {
            pid: selectedChat?.pid,
            message: {
                text: `<span class="font-semibold">${problemReport.title}</span><br/><br/>${questionsText}<br/><span class="font-semibold">Additional Info</span><br/>${values.description || "-"}`,
                type: 'message',
                report_problem: true,
            },
        };
    
        setIsProcessing(true);
        const res = await sendMessage(payload);
        setIsProcessing(false);
    
        if (res?.data?.code === 0) {
            cancelProblemReportPopup();
        } else {
            toast.error(res?.data?.msg);
        }
    };

    const descriptionVal = getValues('description');
    const onSpeechAvailable = (text) =>{
        const finalText = ((descriptionVal ? descriptionVal : '')+' '+text).trim()
        setValue('description', finalText)
    }

    return (
        <>
            <PageDialogContent
            contentCls="py-2 px-2 min-h-[40vh] max-h-[60vh] overflow-y-auto"
            hideOverFlow={true}
            contentScroll={false}>
                <form id="problem_report" onSubmit={handleSubmit(onSubmitForm)}>
                    <div className="container mx-auto my-4">
                        <ul className="list-decimal pl-4 text-start">
                            {(problemReport?.data?.question_json || [])?.map((item, index) => (
                                <div className='mb-4 w-[99%]' key={index}>
                                    <li key={index} className="mb-2">{item?.text}</li>
                                    <TextAreaField name={`question_${index}`} title="Answer" rows="2" control={control} errors={errors} />
                                </div>
                            ))}
                        </ul>
                    </div>
                    <div className="mb-4 relative px-4">
                        <div className='flex items-center justify-start'>
                            <p>Additional Information:</p>
                        </div>
                        <SpeechMic transformSpeech={onSpeechAvailable} divCls="absolute right-4 top-5 z-[10]" />

                        <TextAreaField
                            name="description"
                            // data-audio-enabled={"true"}
                            rows="4"
                            control={control}
                            errors={errors}
                        />
                    </div>
                </form>
            </PageDialogContent>
            <PageDialogFooter>
                <BtnComponent text="Cancel" btnType="default" onClick={cancelProblemReportPopup} />
                <BtnComponent text="Report" btnType='primary_theme' loading={isProcessing} form="problem_report" type="submit" disabled={disableBtn} />
            </PageDialogFooter>
        </>
    );
};

export default ProblemReportForm;